import { cn } from '@/utilities/ui'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

const variants = cva(
  [
    'font-mono',
    'font-normal',
    'leading-[150%]',
    'tracking-normal',
    'text-[1.25rem]',
    'bg-olive-1/10',
    'px-[2px]',
    'py-px',
  ],
  {
    defaultVariants: {},
    variants: {},
  },
)

const Code: React.FC<
  {
    ref?: React.Ref<HTMLPreElement>
  } & React.HTMLAttributes<HTMLPreElement> &
    VariantProps<typeof variants>
> = ({ className, ref, ...props }) => {
  return <code className={cn(variants({ className }))} ref={ref} {...props} />
}

export { Code }
